import { render } from "./spesaItemTable.vue?vue&type=template&id=e513dcce&ts=true"
import script from "./spesaItemTable.vue?vue&type=script&lang=ts"
export * from "./spesaItemTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__